export default "__VITE_ASSET__CieLkmJz__"